import { style } from '@/styles/globals';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import WideTableCellCenter from '../WideTableCellCenter';

const StyledButton = styled(Button)`
  color: white;
  background: ${style.primary.navy};
  border-radius: 2px;
  border: 0;
`;

export const ReserveButton = ({ onClick, lang }: any) => (
  <WideTableCellCenter align="center">
    <StyledButton onClick={onClick}>
      {lang?.global?.bookTickets || 'Đặt vé'}
    </StyledButton>
  </WideTableCellCenter>
);
